import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GenericStyles.css';

const ChangePassword = () => {
    const [username, setUsername] = useState(''); // Username for faculty
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [userType, setUserType] = useState('faculty'); // State for selecting user type
    const [departments, setDepartments] = useState([]); // For department dropdown
    const [departmentId, setDepartmentId] = useState(''); // Selected department ID
    const [isLoading, setIsLoading] = useState(false); // Loading state
    const navigate = useNavigate();

    // Fetch departments for dropdown when userType is department
    useEffect(() => {
        if (userType === 'department') {
            const fetchDepartments = async () => {
                try {
                    const response = await fetch('http://121.52.154.120:3001/api/departments');
                    if (!response.ok) throw new Error('Failed to fetch departments.');
                    const data = await response.json();
                    setDepartments(data.data || []);
                } catch (error) {
                    console.error('Error fetching departments:', error);
                    alert('Unable to load departments. Please try again later.');
                }
            };
            fetchDepartments();
        }
    }, [userType]);

    const handleChangePassword = async (event) => {
        event.preventDefault();

        if (userType === 'department' && !departmentId) {
            alert('Please select a department.');
            return;
        }

        if (!currentPassword || !newPassword || newPassword !== confirmPassword) {
            alert(newPassword !== confirmPassword
                ? 'New passwords do not match.'
                : 'All fields are required.');
            return;
        }

        if (userType === 'faculty' && !username) {
            alert('Please enter your username.');
            return;
        }

        setIsLoading(true);
        try {
            const endpoint = userType === 'faculty'
                ? 'http://121.52.154.120:3001/faculty/change-password'
                : 'http://121.52.154.120:3001/department/change-password';

            const token = localStorage.getItem('authToken');
            if (!token) throw new Error('No authentication token found.');

            const payload = userType === 'faculty'
                ? { username, currentPassword, newPassword } // Faculty uses username
                : { username: departmentId, currentPassword, newPassword }; // Department uses departmentId as username

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Include JWT token
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Password change failed.');
            }

            alert('Password changed successfully.');
            navigate('/facultylogin');
        } catch (error) {
            console.error('Error changing password:', error.message);
            alert(`An error occurred: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="change-password">
            <header className="height-100">
                <h1 className="text-center fw-semibold">Change Password</h1>
            </header>
            <div className="container my-5">
                <form onSubmit={handleChangePassword}>
                    <div>
                        <label>User Type:</label>
                        <select
                            value={userType}
                            onChange={(e) => setUserType(e.target.value)}
                            required
                        >
                            <option value="faculty">Faculty</option>
                            <option value="department">Department</option>
                        </select>
                    </div>

                    {userType === 'faculty' && (
                        <div>
                            <label>Username:</label>
                            <input
                                type="text"
                                placeholder="Enter Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                    )}

                    {userType === 'department' && (
                        <div>
                            <label>Department:</label>
                            <select
                                value={departmentId}
                                onChange={(e) => setDepartmentId(e.target.value)}
                                required
                            >
                                <option value="">Select Department</option>
                                {departments.map((dept) => (
                                    <option key={dept.id} value={dept.id}>
                                        {dept.deptname}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <input
                        type="password"
                        placeholder="Current Password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <button type="submit" disabled={isLoading}>
                        {isLoading ? 'Processing...' : 'Change Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
